import { gql } from 'modes/common/gql';

export type PhoneInput = ReturnType<typeof gql.scalar<'PhoneInput'>> & {
  id?: string;
};
export type PhoneType = PhoneInput['subType'];

export type EmailInput = ReturnType<typeof gql.scalar<'EmailInput'>> & {
  id?: string;
};
export type EmailType = EmailInput['subType'];

export type ContactProfileInput = ReturnType<typeof gql.scalar<'ProfileInput'>>;
export type ProfileType = ContactProfileInput['type'];

export const profileTypes: { value: ProfileType; label: string }[] = [
  { value: 'COMPANY', label: 'Company' },
  { value: 'INDIVIDUAL', label: 'Individual' },
];
